/**
 * num >= 10000 → 1.2万
 * num < 10000 → 9,999
 * @param {number} num
 */
export const formatPretty = (num) => {
  if (num >= 10000) {
    return `${Math.floor(num / 1000) / 10}万`;
  }

  return num.toLocaleString();
};
